<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("genre", 1) }}
      </div>
      <router-link class="btn-blue" to="genres"
        >{{ $tc("genre", 1) }} {{ $tc("list", 1) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Genre"
          :key="index"
          v-if="item.fieldname !== 'g_id'"
          class="col-lg-6 col-xl-4 align-self-center mb-4"
        >
          <div
            v-if="
              item.fieldname !== 'g_is_active' &&
              item.fieldname !== 'visible_on_website'
            "
          >
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                  v-b-tooltip.hover.top="$t(item.tooltip)"
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has(item.fieldname)">{{
                errors.first(`${item.fieldname}`)
              }}</span>
            </p>
          </div>
          <div v-if="item.fieldname === 'g_is_active'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <!-- <label class="ios-switch"> -->
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox"
                v-model="item.fieldvalue"
              />
              <!-- <span class="switch-slider"></span>
              </label> -->
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>

          <div v-if="item.fieldname === 'visible_on_website'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t("Visible On Website") }}</label>
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox"
                unchecked-value="N"
                value="Y"
                v-model="visible_on_website"
              />
            </div>
          </div>
        </div>

        <div class="col-12">
          <TranslationsContainer :translationsObj="translationsObj" />
        </div>
        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="handleSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetHandler()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="genres">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Genre from "@/helper/formJSONMaster/Genre";
import TranslationsContainer from "@/components/Partials/translationsFields.vue";

export default {
  components: {
    TranslationsContainer,
  },
  data() {
    return {
      btenable: false,
      Genre: Genre.ms_genre,
      // v-validate="'required|email'"
      submitted: false,
      Methods: Genre.Methods,
      translationsObj: {},
      visible_on_website: false,
    };
  },
  mounted() {
    console.log("Genre :", Genre);
    this.resetHandler();
  },
  methods: {
    onFocusHandler: function () {
      // this.submitted = false;
    },
    resetHandler: function () {
      this.Genre.map((x) => {
        if (x.type === "text" || x.type === "date" || x.type === "number") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    checkDuplicateGOrder(g_order) {
      return MasterService.checkGOrderExists(g_order).then((response) => {
        return response.data.exists;
      });
    },

    handleSubmit(flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.btenable = true;

          const g_order = this.Genre.find(
            (item) => item.fieldname === "g_order"
          ).fieldvalue;

          this.checkDuplicateGOrder(g_order).then((isDuplicate) => {
            if (isDuplicate) {
              this.$toasted.show(
                "The order number is already in use. Please choose another."
              );
              this.btenable = false;
            } else {
              let body = this.getRequestBody("POST", this.Genre, this.Methods);
              body.payload = {
                ...body.payload,
                translationsObj: this.translationsObj,
                visible_on_website: this.visible_on_website,
              };

              MasterService.GlobalRequest(body)
                .then((response) => {
                  this.btenable = false;
                  const { data } = response;
                  if (data.status) {
                    if (flag) {
                      this.$router.push({ path: "/master/genres" });
                    } else {
                      this.resetHandler();
                    }
                  } else {
                    this.$toasted.show(data.message);
                    this.resetHandler();
                  }
                })
                .catch((error) => {
                  console.log("Error:", error);
                });
            }
          });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/GenreComponents/addGenre.vue